import { RouterActionTypes } from '../actions/router.action.types';
var defaultState = [];
export var RouteConfigurationReducer = function (state, action) {
    if (state === void 0) { state = defaultState; }
    if (action.type !== RouterActionTypes.ADD_ROUTE_CONFIGURATION) {
        return state;
    }
    var alreadyConfiguredRouteIndex = state.findIndex(function (route) { return route.applicationName === action.payload.applicationName; });
    if (alreadyConfiguredRouteIndex >= 0) {
        return state.slice(0, alreadyConfiguredRouteIndex).concat([
            state[alreadyConfiguredRouteIndex] = action.payload
        ], state.slice(alreadyConfiguredRouteIndex + 1));
    }
    else {
        return state.concat([action.payload]);
    }
};
//# sourceMappingURL=routeConfiguration.reducer.js.map